import { ContactUsForm } from "./ContactUsForm";

export const Modal = (props) => {

    const imageUrl = props.imageUrl;
    const isOpen = props.isOpen;

    const closeModal = props.closeModal;

    if (!isOpen) {
        return null;
    }

    // Show the image closer up for users to see details
    if (isOpen && imageUrl) {
        return <div className="modal-container" onClick={closeModal}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
                <img className="modal-image" src={imageUrl} alt="Modal view of roof painting" />
            </div>
        </div>
    }

    if (isOpen && !imageUrl) {
        return <div className="modal-container" onClick={closeModal}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
                <ContactUsForm />
            </div>
        </div>
    }
}